import { render, staticRenderFns } from "./AddVendorLocation.vue?vue&type=template&id=44ad2af1"
import script from "./AddVendorLocation.vue?vue&type=script&lang=ts"
export * from "./AddVendorLocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports